import noEventsImg from "../../../../../assets/GifsAndPlaceholders/noEventsUndraw.png"
import { Timestamp } from "firebase/firestore";
import { DocumentReference } from "firebase/firestore";
import EventsListRenderer from "./EventsListRenderer";
import { Ticket } from "../../../../PlundrComponents/types/PartnerTypes";
import { useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { db } from '../../../../../Config/firebase';
import { collection, query, onSnapshot, orderBy } from 'firebase/firestore';
import { RootState, useAppSelector } from '../../../../../state/state';
import 'firebase/compat/firestore';
import { openModal } from '../../../../../state/ModalSlice/ModalSlice';
import { selectEffectiveUID } from "../../../../../state/UserStatesV2/userSliceV2";


export type EventData = {
    id: string;
    eCategory: string; // "Fitness"
    eEndTime: Timestamp; // "16 Oct"
    eName: string; // "VaishAkh"
    ePromoImage: string; // URL to the promo image
    eRegsStartTime: Timestamp; // "16 Oct"
    eStartTime: Timestamp; // "18 Oct"
    eStatus: string; // "Active"
    eSummary: string; // Description of the event
    eTermsConditions: string; // Terms and conditions for the event
    eVenue: string; // Venue of the event
    isOpen: boolean; // Whether the event is open
    tickets: Ticket[]; // Array of ticket information
    eGeoLocation: eGeoLocation,
    address: string;
    city: string;
    latlang: any; // [latitude, longitude]
    locality: string;
    pin: string;
    state: string;
    sublocalities: string[];
    formattedAddress: string;
    participants: number;
    eventRef: DocumentReference;
    placeName: string;
    eventLink: string;

};

type eGeoLocation = {
    address: string;
    city: string;
    latlang: any; // [latitude, longitude]
    locality: string;
    pin: string;
    placeName: string;
    state: string;
    sublocalities: string[];
    formattedAddress: string;
}




export default function EventssContainer({ showAllEvents }: { showAllEvents: boolean }) {

    const [events, setEvents] = useState<EventData[]>([]);
    const providerId: string = useAppSelector(selectEffectiveUID);
    const dispatch = useDispatch();


    // Reference to store the unsubscribe function
    const unsubscribeRef = useRef<() => void | undefined>();

    useEffect(() => {
        if (providerId) {
            const eventsRef = collection(db, 'ServiceProviders', providerId, 'Events');
            const q = query(eventsRef, orderBy('eStartTime', 'asc'));

            const unsubscribe = onSnapshot(q, (snapshot) => {
                const eventsList: EventData[] = [];
                snapshot.forEach((doc) => {
                    eventsList.push({ id: doc.id, ...doc.data() } as EventData);
                });
                setEvents(eventsList);
            }, (error) => {
                console.error("Error fetching events: ", error);
            });

            // Store the unsubscribe function 
            unsubscribeRef.current = unsubscribe;

            // Cleanup function
            return () => {
                if (unsubscribeRef.current) {
                    unsubscribeRef.current();
                }
            };
        }
    }, [providerId]);


    const filteredEvents: EventData[] = events.filter(event => {
        if (showAllEvents) return true;
        
        const today = new Date();
        const eventEndDate = event.eEndTime.toDate();
        return eventEndDate >= today;
    });

    const handleAddEvent = () => {
        dispatch(openModal('AddEventsModalOpen'));
    }

   


    return (
        <div className="flex flex-col items-center justify-center border-t-solid border-t-[2px] border-t-gray-200 pt-6 pb-8 ">
            {filteredEvents.length === 0 ? (
                <>
                    <img
                        src={noEventsImg}
                        alt="No events"
                        className="w-52 h-auto mb-4"
                    />
                    <p className="text-gray-500 mb-2">No Events Created Yet!</p>
                    <button onClick={handleAddEvent} className="text-blue-600 hover:text-blue-700">
                        Create Event
                    </button>
                </>
            ) : (
                <div className="overflow-y-auto max-h-[50rem] px-2 w-full diff-scrollbar">
                    {filteredEvents.map((event) => (
                        <EventsListRenderer key={event.id} event={event} />
                    ))}
                </div>
            )}
        </div>
    )
}